import { io } from 'socket.io-client';

const SOCKET_URL = 'https://yoospeak.app:5000/';

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
  }

  connect() {
    if (this.socket) {
      return this.socket;
    }

    const token = localStorage.getItem('authToken');

    // We assume the backend validates via some means or we authenticate after connection
    this.socket = io(SOCKET_URL, {
      transports: ['websocket'],
      // auth: { token } // If backend requires token in handshake
    });

    this.socket.on('connect', () => {
      this.isConnected = true;
      console.log('Connected to socket server:', this.socket.id);

      // Auto authenticate if user info exists in local storage
      const userStr = localStorage.getItem('user');
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          if (user && user._id) {
            this.authenticate(user._id);
          }
        } catch (e) {
          console.error('Error parsing user for socket auth', e);
        }
      }
    });

    this.socket.on('disconnect', () => {
      this.isConnected = false;
      console.log('Disconnected from socket server');
    });

    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  authenticate(userId) {
    if (this.socket && this.isConnected) {
      this.socket.emit('authenticate', userId);
    }
  }

  getSocket() {
    return this.socket;
  }
}

const socketInstance = new SocketService();
export default socketInstance;
